import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectLocale } from 'models/localization';
import { selectBoothTabsByIds } from 'models/cms/boothTabs';

const useEmailContactsMemo = (tabs) => {
  const locale = useSelector(selectLocale);
  const boothTabs = useSelector(selectBoothTabsByIds(tabs));

  const emailContacts = useMemo(
    () => boothTabs
      .flatMap((it) => it.body)
      // eslint-disable-next-line no-underscore-dangle
      .filter((it) => it?.__typename === 'BoothQuestionContentElement' && it?.answer?.contentRichtextHtml?.[locale])
      .map((it) => ({
        type: 'email',
        contact: it.answer.contentRichtextHtml[locale].match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)?.[0],
      }))
      .filter((it) => it.contact),
    [boothTabs, locale],
  );

  return emailContacts;
};

export default useEmailContactsMemo;
